import React from 'react';
import { css } from '@emotion/react';
import { i18n_browse_docs_and_films } from '@yi/i18n/phrases/i18n_browse_docs_and_films';

import { LazyRender } from '~/src/components/LazyRender';
import { AllSeriesCarousel } from '~/src/components/LeanBack/AllSeriesCarousel';
import { SeriesCard } from '~/src/components/LeanBack/common-components/SeriesCard';
import { useLocale } from '~/src/components/LocaleProvider';
import { typography } from '~/src/styles/design-system';
import { breakpoints } from '~/src/styles/styled-mixins';
import { fontWeight } from '~/src/styles/styled-variables';

import { carouselSettings, spaceBetweenCards } from '../carouselSettings';

const overrideSlickCarouselCSS = css([
  carouselSettings.overrideSlickCarouselCSS,
  {
    'a:hover': {
      transform: 'unset',
    },
  },
]);

const headerCSS = css(carouselSettings.headerCSS, {
  span: css(typography.heading2, {
    fontWeight: fontWeight.semiBold,
    textTransform: 'capitalize',
    color: 'var(--Dark-Text, #27292D)',
    margin: 0,
    [breakpoints.minTablet]: [
      typography.bodyText,
      {
        fontWeight: fontWeight.bold,
      },
    ],
    [breakpoints.minDesktop]: {
      color: 'var(--Dark-Text, #27292D)',
      fontSize: '32px',
      fontWeight: fontWeight.semiBold,
      lineHeight: '40px',
      letterSpacing: '1.6px',
    },
  }),
});

export const DocsAndFilmsCarousel: React.FC<{ className?: string }> = props => {
  const { locale } = useLocale();

  return (
    <div {...props}>
      <LazyRender placeholder={<AllSeriesCarousel.Placeholder />}>
        <AllSeriesCarousel
          heading={i18n_browse_docs_and_films(locale)}
          {...carouselSettings}
          deprecatedEnableCarouselInvisibleCard={true}
          overrideSlickCarouselCSS={overrideSlickCarouselCSS}
          headerCSS={headerCSS}
          style={{ width: `${SeriesCard.dimension.width + spaceBetweenCards}px` }}
        />
      </LazyRender>
    </div>
  );
};
